import { combineReducers } from "@reduxjs/toolkit";
import { appSlice } from "./app/appSlice";
import { configSlice } from "./config/configSlice";
import { ExampleSlice } from "./example/ExampleSlice";
import { langSlice } from "./lang/langSlice";
import { LoginSlice } from "./login/LoginSlice";
import { TokenSlice } from "./token/TokenSlice";
import { userSlice } from "./user/userSlice";
import { cnpjSlice } from "./cnpj/cnpjSlice";
import { dashboardSlice } from "./dashboard/dashboardSlice";
import { dateSlice } from "./date/dateSlice";
import { VolksAssetTreeSlice } from "./volksAssetTree/volksAssetTreeSlice";
import { VolksCustomAssetTreeSlice } from "./volksCustomAssetTree/volksCustomAssetTreeSlice";
import { TmsAssetTreeSlice } from "./tmsAssetTree/tmsAssetTreeSlice";
import { dreDateSlice } from "./dreDate/dreDateSlice";

export const reducers = combineReducers({
  example: ExampleSlice.reducer,
  lang: langSlice.reducer,
  config: configSlice.reducer,
  app: appSlice.reducer,
  user: userSlice.reducer,
  login: LoginSlice.reducer,
  tokenHandling: TokenSlice.reducer,
  cnpj: cnpjSlice.reducer,
  dashboard: dashboardSlice.reducer,
  date: dateSlice.reducer,
  volksAssetTree: VolksAssetTreeSlice.reducer,
  volksCustomAssetTree: VolksCustomAssetTreeSlice.reducer,
  tmsAssetTree: TmsAssetTreeSlice.reducer,
  dreDate: dreDateSlice.reducer,
});
